import { render, staticRenderFns } from "./Wave.vue?vue&type=template&id=54ee9bfd&scoped=true&"
import script from "./Wave.vue?vue&type=script&lang=js&"
export * from "./Wave.vue?vue&type=script&lang=js&"
import style0 from "./Wave.vue?vue&type=style&index=0&id=54ee9bfd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ee9bfd",
  null
  
)

export default component.exports